import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CheckoutModel } from 'src/core/model/quarter-overview.model';
import { CheckoutTable } from '../checkout-table/checkout-table';

export type CheckoutSectionProps = {
  readonly list: CheckoutModel[];
};

export function CheckoutSection(
  props: CheckoutSectionProps,
): React.JSX.Element {
  const { list } = props;
  const { t } = useTranslation();

  return (
    <div>
      <Typography variant="h6" gutterBottom component="div">
        {t('quarter-overview.checkout-section.title', {
          count: list.length,
        })}
      </Typography>

      {list.length > 0 && <CheckoutTable list={list} />}
    </div>
  );
}
